import { useEffect } from 'react';

export const useScrollToTopOnMount = () => {
  useEffect(() => {
    const mainLayoutElement = document.querySelector('#__main');
    if (mainLayoutElement) {
      mainLayoutElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);
};

export const useModifyBodyScrollOverflow = (
  condition: boolean,
  newOverflow: string = 'hidden'
) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const prevOverflow = document.body.style.overflow;
    if (condition) {
      document.body.style.overflow = newOverflow;
    } else {
      document.body.style.overflow = prevOverflow;
    }
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [condition]);
};
